import { render, staticRenderFns } from "./StaffIndividualAwayAssignmentModal.vue?vue&type=template&id=959db426&scoped=true&"
import script from "./StaffIndividualAwayAssignmentModal.vue?vue&type=script&lang=js&"
export * from "./StaffIndividualAwayAssignmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959db426",
  null
  
)

export default component.exports